import React from "react";
import { useT } from "../i18n/I18nProvider";

const LOGO = "/elsol-logo.png";

export default function Header() {
  const { t, lang, toggle } = useT();

  const links = [
    { href: "#about", key: "story" },
    { href: "#categories", key: "shop" },
    { href: "#specials", key: "specials" },
    { href: "#gallery", key: "gallery" },
    { href: "#visit", key: "visit" },
    { href: "#contact", key: "contact" },
  ];

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-md bg-[#fdfbf7]/90 border-b border-stone-900/10"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-[88px] flex items-center justify-between gap-4">
        <a
          href="#home"
          data-testid="brand-link"
          aria-label="El Sol Mexican Imports"
          className="flex items-center group flex-shrink-0"
        >
          <img
            src={LOGO}
            alt="El Sol Mexican Imports"
            className="h-20 w-auto object-contain transition-transform group-hover:scale-105"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="Primary">
          {links.map((l) => (
            <a
              key={l.key}
              href={l.href}
              data-testid={`nav-${l.key}`}
              className="text-[14px] font-semibold text-stone-700 hover:text-[#8c2f08] transition-colors relative group whitespace-nowrap"
            >
              {t(`nav.${l.key}`)}
              <span className="absolute -bottom-1 left-0 right-0 h-[2px] bg-[#b8420f] scale-x-0 group-hover:scale-x-100 transition-transform origin-left" />
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
          {/* Language toggle */}
          <button
            type="button"
            onClick={toggle}
            data-testid="lang-toggle-btn"
            aria-label={t("nav.switch_to")}
            title={t("nav.switch_to")}
            className="inline-flex items-center gap-1.5 rounded-full border border-stone-300 hover:border-[#b8420f] bg-white px-3 py-2 text-[12px] font-bold tracking-wide text-stone-700 hover:text-[#b8420f] transition-colors"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="12" cy="12" r="10"/>
              <path d="M2 12h20"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
            </svg>
            <span data-testid="lang-current" className={lang === "en" ? "text-[#b8420f]" : ""}>EN</span>
            <span className="text-stone-400">·</span>
            <span data-testid="lang-other" className={lang === "es" ? "text-[#b8420f]" : ""}>ES</span>
          </button>

          <a
            href="tel:+18176561046"
            data-testid="header-call-btn"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#14532d] hover:bg-[#0f3d21] text-white px-4 py-2 text-[13px] font-semibold transition-colors"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.93.37 1.84.7 2.71a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.37-1.27a2 2 0 0 1 2.11-.45c.87.33 1.78.57 2.71.7A2 2 0 0 1 22 16.92z"/></svg>
            (817) 656-1046
          </a>
        </div>
      </div>
    </header>
  );
}
